import { gql } from "@apollo/client";

export const GET_ALL_SERVICES = gql`
  query GetAllServices(
    $companyId: ID
    $pagination: pagination
    $searchText: String
    $sort: sort
  ) {
    getAllServices(
      companyId: $companyId
      pagination: $pagination
      searchText: $searchText
      sort: $sort
    ) {
      services {
        _id
        title
        company
        icon
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

export const GET_SERVICE_BY_ID = gql`
  query GetServiceById($serviceId: ID!) {
    getServiceById(serviceId: $serviceId) {
      _id
      icon
      title
      company
      createdAt
      updatedAt
    }
  }
`;

export const ADD_SERVICE = gql`
  mutation AddService($serviceInput: ServiceInput) {
    addService(ServiceInput: $serviceInput) {
      _id
      icon
      title
      company
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_SERVICE = gql`
  mutation UpdateService($serviceInput: ServiceInput) {
    updateService(ServiceInput: $serviceInput) {
      _id
      icon
      title
      company
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_SERVICE = gql`
  mutation DeleteService($serviceId: ID!) {
    deleteService(serviceId: $serviceId) {
      _id
      icon
      title
      company
      createdAt
      updatedAt
    }
  }
`;
